export * from './baKameleonPicture.pipe';



// WEBPACK FOOTER //
// /Users/Miroslav/Projects/Dubravica/backoffice/src/app/theme/pipes/baKameleonPicture/index.ts